import type { ResponsiveImageTransformations } from '#core/utils/getImageTransformations'
import type { Responsive } from '#types/common'

/**
 * Sizes a `focused-product-espot` asset override for the card it leads.
 *
 * Product media is one URL that every breakpoint is sized from, while an override authors a URL per
 * breakpoint - each is transformed on its own so the result still slots into `base-picture`'s `src`.
 * @param urls - The override URL for each breakpoint, as resolved by `resolveFocusedProducts`.
 * @param transformations - Transformations to apply, sized per breakpoint.
 * @returns Transformed URLs keyed by breakpoint.
 * @category Utils
 */
export const getAssetOverrideSrc = (
  urls: Responsive<string>,
  transformations: ResponsiveImageTransformations = {}
): Responsive<string> =>
  Object.entries(urls).reduce((sources, [breakpoint, url]) => ({
    ...sources,
    [breakpoint]: getResponsiveImageTransformations(url, transformations)[breakpoint]
  }), {} as Responsive<string>)
